import React from 'react'
import Step from '../../components/Step'
import ButtonSelect from '../../elements/ButtonSelect'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const wallConstruction = fieldName('wallConstruction');

export const rules = {
    [wallConstruction]: []
}


export default () => {
    const navigation = Resi.useNavigation();
    const fields = Resi.useFields();
    const options = Resi.useOptions();

    function onSelected(value:string){
        fields.setValue(wallConstruction)(value);
        navigation.goToNext();
    }

    return (
        <Step>
            <h2>Tell us about the main building material of the walls.</h2>
            <p>If different building materials have been used, please select the primary type of material.</p>
            <ButtonSelect 
                options={ options.data.product.WALL_CONSTRUCTION }
                selected={fields.value(wallConstruction)}
                colsLg={ 3 }
                colsSm={ 1 }
                callback={ onSelected }
            />
        </Step>
    )
};